import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
// import { FaEnvelopeOpenText } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const InternshipCTA: React.FC = () => {
  const navigate = useNavigate(); // ✅ hook

  return (
    <section className="internship-cta">
      <Container>
        <Row className="align-items-center">
          <Col md={8} className="cta-left d-flex align-items-center">
            {/* <div className="cta-icon">
            {React.createElement(FaEnvelopeOpenText)}
            </div> */}
            <h2 className="cta-title mb-0">Get Internships</h2>
          </Col>

          <Col md={4} className="text-md-end text-start mt-3 mt-md-0">
            <Button
              className="cta-btn"
              onClick={() => navigate("/internships")}
            >
              JOIN NOW →
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default InternshipCTA;
